import { useState } from 'react';
import Container from './components/Container';
import { Col, Row } from './components/Grid';
import PageTitle from './components/PageTitle';
import Calculator from './components/Calculator';
import { uuid } from './utils/rand';

function App() {
  const [calculators, setCalculators] = useState([uuid()]);

  const handleRemove = (id) => window.confirm('Poista tämä laskuri?') && setCalculators(calculators.filter((x) => x !== id));
  const handleAdd = () => setCalculators(calculators.concat(uuid()));

  return (
    <Container>
      <Row>
        <Col size="5">
          <PageTitle />
        </Col>

        <Col size="7">
          {calculators.map((id, i) => (
            <Calculator
              key={id}
              id={id}
              isLast={i === calculators.length - 1}
              onRemove={handleRemove}
              onAdd={handleAdd}
            />
          ))}
        </Col>
      </Row>
    </Container>
  );
}

export default App;
